import { createSlice } from '@reduxjs/toolkit';

import type {
  MapState,
  setMapDataType,
  setActiveHotelType,
  setPopupDataType,
} from './types';

const initialState: MapState = {
  bounds: undefined,
  zoom: undefined,
  center: undefined,
  activeHotel: undefined,
  expanded: false,
  popupData: undefined,
  regions: [],
};

const map = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapData: (state, action: setMapDataType) => {
      const { bounds, regions, zoom, center } = action.payload;

      state.bounds = bounds;
      state.regions = regions;
      state.zoom = zoom;
      state.center = center;
    },
    setActiveHotel: (state, action: setActiveHotelType) => {
      state.activeHotel = action.payload;
    },
    setPopupData: (state, action: setPopupDataType) => {
      state.popupData = action.payload;

      if (action.payload) {
        const { id, coordinates, visited } = action.payload;
        state.activeHotel = { id: Number(id), coordinates, visited };
      }
    },
    resetPopupData: (state) => {
      state.popupData = initialState.popupData;
      state.activeHotel = initialState.activeHotel;
    },
    toggleMap: (state) => {
      state.expanded = !state.expanded;
    },
  },
});

export const {
  setMapData,
  setActiveHotel,
  setPopupData,
  resetPopupData,
  toggleMap,
} = map.actions;

export const { name } = map;
export { initialState };

export default map.reducer;
